import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ParcelTracking from "./components/ParcelTracking";

function App() {
  return (
    <div className="main-container">
      <Router>
        <Routes>
          <Route path="/" element={<ParcelTracking />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
